module.exports = __webpack_public_path__ + "static/media/karnaforge_logo.c89a436d.png";